module.exports = __webpack_public_path__ + "img/yilianGl20.2b043b98.png";